/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import { SettingsContent, SettingsGlyph } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function SideSettingsButton({
  onPress,
  focused,
}: {
  onPress?: () => void;
  focused?: boolean;
}) {
  return (
    <>
      <SettingsContent onPress={onPress} focused={focused}>
        <SettingsGlyph aria-hidden="true" data-no-tts>
          ⚙
        </SettingsGlyph>
      </SettingsContent>
    </>
  );
});
